import React, { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { causeEffectStyles } from "./CloudProCauseeffectshared";
import MatrixToPanel from "./CloudProMatrixToPanel";

const CloudProCauseEffect = () => {
const [openSnackbar, setOpenSnackbar] = useState(false);
const [alertMsg, setAlertMsg] = useState("");
const [alertType, setAlertType] = useState("success");
const [maxDelay, setMaxDelay] = useState(5);

const notify = (type, msg) => {
setAlertType(type);
setAlertMsg(msg);
setOpenSnackbar(true);
};

return (
<> <style>{causeEffectStyles}</style>

  <MatrixToPanel
    maxDelay={maxDelay}
    setMaxDelay={setMaxDelay}
    notify={notify}
  />

  <Snackbar
    open={openSnackbar}
    autoHideDuration={3000}
    onClose={() => setOpenSnackbar(false)}
  >
    <Alert
      onClose={() => setOpenSnackbar(false)}
      severity={alertType}
      variant="filled"
    >
      {alertMsg}
    </Alert>
  </Snackbar>
</>


);
};

export default CloudProCauseEffect;
